import {IController, IModule} from "angular";
import {MøteProsessStegModell} from "../møteProsessOversikt";
import {C3TodeltPieKonfig} from "../../../../../../felles/komponenter/c3TodeltPie/c3TodeltPie";

require('./møteProsessSteg.scss');

export class MøteProsessStegKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
          .component('wmMoeteProsessSteg', {
              bindings: {modell: '<', c3TodeltPieKonfig: '<', vedKlikk: '&'},
              controller: MøteProsessStegKontroller.forInjisering(),
              template: require('./møteProsessSteg.html')
          });
    }

    static forInjisering() {
        return [MøteProsessStegKontroller]
    }

    constructor() {
    }

    modell: MøteProsessStegModell; //settes via bindings
    c3TodeltPieKonfig: C3TodeltPieKonfig; //settes via bindings
    vedKlikk: (modell: MøteProsessStegModell) => void;
    
    viserHandlingKanIkkeUtfoeresInformasjon = false;

    haandterKlikk() {
        if (this.modell.handlingKanIkkeUtfoeresInformasjon) {
            this.viserHandlingKanIkkeUtfoeresInformasjon = true;
        } else {
            this.vedKlikk(this.modell);
        }
    }
    
}
